<div class="card">
  <div class="card-title">
    <div class="text-center mt-3">
      <h4>State Wise Data Covid-19 India</h4>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class = 'chart-custom'>
          <canvas id="mychart" ></canvas>
        </div>
      </div>
      <div class="col-sm-6 mt-5">
          <div class="containter custom-padding">
            <div class="row">
              <div class="col-sm-6">Confirmed</div>
              <div class = 'col-sm-6'>{{idData.confirmed}} </div>
            </div>
            <div class="row">
              <div class="col-sm-6">Active</div>
              <div class = 'col-sm-6'>{{idData.active}} </div>
            </div>

            <div class="row">
              <div class="col-sm-6">Recovered</div>
              <div class = 'col-sm-6'>{{idData.recovered}} </div>
            </div>
            <div class="row">
              <div class="col-sm-6">Deaths</div>
              <div class = 'col-sm-6'>{{idData.deaths}} </div>
            </div>
          </div>

      </div>
    </div>
    <table class = 'table bg-light mt-3'>

      <th scope="col">#</th>
      <th scope="col">State Name</th>
      <th scope="col">Total Cases</th>
        <th scope="col">Deaths</th>
      <th scope="col">Recovered</th>


    <tbody>
      <tr *ngFor = "let Data of data; let i = index">

        <!-- "'/profile/' + user.uid" -->
          <td>{{i+1}}</td>
          <td><a [routerLink] = "'/state/' + Data.state">{{Data.state}}</a></td>
          <td>{{Data.confirmed}}</td>
          <td>{{Data.deaths}}</td>
          <td>{{Data.recovered}}</td>



      </tr>
    </tbody>
    </table>


  </div>
</div>
